import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "page-bg" }, null, -1)
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "popup" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "outer" }, null, -1)
const _hoisted_6 = { class: "sidebar" }
const _hoisted_7 = { class: "sidebar-top" }
const _hoisted_8 = { class: "sidebar-bottom" }
const _hoisted_9 = { class: "swiper-wrapper" }
const _hoisted_10 = { class: "swiper-slide swiper-no-swiping" }
const _hoisted_11 = { class: "swiper-slide swiper-no-swiping" }
const _hoisted_12 = { class: "swiper-slide swiper-no-swiping" }
const _hoisted_13 = { class: "part3" }
const _hoisted_14 = { class: "man scale-in" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<a href=\"javascript:void(0);\" class=\"man-1-hover\"></a><a href=\"javascript:void(0);\" class=\"man-1\"></a><div class=\"man-card-1 scale-in\"></div><a href=\"javascript:void(0);\" class=\"man-2\"></a><div class=\"man-card-2 scale-in\"></div><a href=\"javascript:void(0);\" class=\"man-3\"></a><div class=\"man-card-3 scale-in\"></div><a href=\"javascript:void(0);\" class=\"man-4\"></a><div class=\"man-card-4 scale-in\"></div><a href=\"javascript:void(0);\" class=\"man-5-hover\"></a><a href=\"javascript:void(0);\" class=\"man-5\"></a><div class=\"man-card-5 scale-in\"></div><a href=\"javascript:void(0);\" class=\"man-6\"></a><div class=\"man-card-6 scale-in\"></div><a href=\"javascript:void(0);\" class=\"man-7-hover\"></a><a href=\"javascript:void(0);\" class=\"man-7\"></a><div class=\"man-card-7 scale-in\"></div><a href=\"javascript:void(0);\" class=\"man-8\"></a><div class=\"man-card-8 scale-in\"></div>", 19)
const _hoisted_34 = [
  _hoisted_15
]
const _hoisted_35 = { class: "woman scale-in" }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<a href=\"javascript:void(0);\" class=\"woman-1\"></a><div class=\"woman-card-1 scale-in\"></div><a href=\"javascript:void(0);\" class=\"woman-2\"></a><div class=\"woman-card-2 scale-in\"></div><a href=\"javascript:void(0);\" class=\"woman-3-hover\"></a><a href=\"javascript:void(0);\" class=\"woman-3\"></a><div class=\"woman-card-3 scale-in\"></div><a href=\"javascript:void(0);\" class=\"woman-4\"></a><div class=\"woman-card-4 scale-in\"></div><a href=\"javascript:void(0);\" class=\"woman-5\"></a><div class=\"woman-card-5 scale-in\"></div><a href=\"javascript:void(0);\" class=\"woman-6\"></a><div class=\"woman-card-6 scale-in\"></div><a href=\"javascript:void(0);\" class=\"woman-7\"></a><div class=\"woman-card-7 scale-in\"></div><a href=\"javascript:void(0);\" class=\"woman-8\"></a><div class=\"woman-card-8 scale-in\"></div>", 17)
const _hoisted_53 = [
  _hoisted_36
]
const _hoisted_54 = { class: "swiper-slide swiper-no-swiping" }
const _hoisted_55 = { class: "part4" }
const _hoisted_56 = { class: "part4-left" }
const _hoisted_57 = { class: "part4-left-top" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "nian1" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "nian2" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "nian3" }, null, -1)
const _hoisted_61 = { class: "part4-right" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "nian4" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h2", { class: "part4-title" }, null, -1)
const _hoisted_64 = { class: "swiper-slide swiper-no-swiping" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "footer-copyright-arrow" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "footer-copyright-text font-sc"
}, "©版權資訊", -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-main\"><div class=\"footer-main-logo\"></div><div class=\"footer-main-center\"><p>※本遊戲軟體分級管理辦法分類為：輔15級。</p><p>※本遊戲內含輕度暴力，性（角色穿著凸顯胸、臀之服飾）。</p><p>※本遊戲為免費使用，遊戲內另提供購買虛擬遊戲幣、物品等付費服務。</p><p>※長時間進行遊戲，容易影響正常作息，宜適度休息及運動。</p><p>代理商：珩熠文化網路有限公司</p></div><div class=\"footer-main-right\"><div class=\"degree\"></div><div class=\"links\"><a class=\"link\" href=\"//gpassport.blancozone.com/center/ServicePrivacy/service\" target=\"_blank\">服務條款</a><span class=\"line\">|</span><a class=\"link\" href=\"//gpassport.blancozone.com/center/ServicePrivacy/privacy\" target=\"_blank\">隱私協議</a></div><p class=\"copyright\">©Copyright 2022 www.blancozone.com 版權所有。</p></div></div>", 1)

import { onMounted, nextTick, onUpdated, ref, reactive, getCurrentInstance } from 'vue';
import Part1 from './Part1.vue';
import Part2 from './Part2.vue';
import Part5 from './Part5.vue';
import CommonSwiper from '@/components/CommonSwiper.vue';
import ReservePopup from '@/components/ReservePopup.vue';
import TipPopup from '@/components/TipPopup.vue';
import FbFans from '../components/FbFans.vue';
import roleHook from '@/hooks/roleHook';
import { visibleTipPopup, tipClass, tipMsg } from '@/hooks/tipHook';
import { visibleReservePopup, showReservePopup } from '@hooks/globalData';
import fbHook from '@/hooks/fbHook';
// import aniHook from '@/hooks/aniHook';
import { point } from '@utils/pointUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const pageState = reactive({
  activeIndex: 0,
});

// 初始化页面切换动画
// const { turnOn, turnOff, visibleCanvas } = aniHook();

// 初始化页面轮播
const currentInstance = getCurrentInstance();
const Swiper =
  currentInstance && (currentInstance.appContext as any).config.globalProperties.$swiper;
let pageSwiper: any = null;
const pageSwiperEle = ref(null);
onMounted(() => {
  nextTick(() => {
    pageSwiper = new Swiper(pageSwiperEle.value, {
      initialSlide: 0,
      direction: 'vertical',
      mousewheel: true,
      speed: 600,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    });

    pageSwiper.on('slideChange', function (this) {
      pageState.activeIndex = this.activeIndex;
      const name = ['首页', '预约报酬', '角色介绍', '场景展示', '游戏特色'][
        this.activeIndex * 1
      ];
      point({
        eventName: 'view_page',
        value: name,
        pageName: '',
        popupName: '',
        buttonName: name,
        popupButtonName: '',
      });
      point({
        eventName: 'click_button',
        value: name,
        pageName: '',
        popupName: '',
        buttonName: name,
        popupButtonName: '',
      });
    });

    // pageSwiper.on('transitionStart', function () {
    //   turnOn();
    // });

    // pageSwiper.on('transitionEnd', function () {
    //   turnOff();
    // });
  });
});
onUpdated(() => pageSwiper && pageSwiper.navigation.update());

// 页面跳转
const changePage = ({ target }) => {
  if (!target) return;
  const index = target.dataset.index;
  if (!index) return;
  pageSwiper.slideTo(index);
};
const activeSwiper1Index = ref(0);

// 初始化世界轮播1
const worldSwiper1 = {
  activeIndex: 0,
  swiperInstance: null,
  autoPlay: false,
  imagesPathList: [
    require('../assets/images/pc/pages/swiper1-1.png'),
    require('../assets/images/pc/pages/swiper1-2.png'),
    require('../assets/images/pc/pages/swiper1-3.png'),
  ],
  openLeftRightChangeBtn: false,
  openPaginationBtn: false,
  changeSwiperCallBack: (index) => {
    activeSwiper1Index.value = index;
  },
  getSwiperInstance: (swiper) => {
    worldSwiper1.swiperInstance = swiper;
  },
  changeSwiper1: ({ target }) => {
    const index = target.dataset.index * 1;
    if (index >= 0 && index <= 2 && worldSwiper1.swiperInstance) {
      // 这个slideTo是从1开始的？？其它API都是0开始的
      worldSwiper1.swiperInstance.slideTo(index + 1);
      activeSwiper1Index.value = index;
    }
  },
};

// 初始化世界轮播2
const worldSwiper2 = {
  imagesPathList: [
    require('../assets/images/pc/pages/swiper3-1.jpg'),
    require('../assets/images/pc/pages/swiper3-2.jpg'),
    require('../assets/images/pc/pages/swiper3-3.jpg'),
    require('../assets/images/pc/pages/swiper3-4.jpg'),
    require('../assets/images/pc/pages/swiper3-5.jpg'),
  ],
  openLeftRightChangeBtn: false,
};

// 初始化人物轮播
const swiper3ImagesPathList = [
  require('../assets/images/swiper/1.jpg'),
  require('../assets/images/swiper/2.jpg'),
  require('../assets/images/swiper/3.jpg'),
  require('../assets/images/swiper/4.jpg'),
  require('../assets/images/swiper/5.jpg'),
  require('../assets/images/swiper/6.jpg'),
  require('../assets/images/swiper/7.jpg'),
];

// 底栏显示与隐藏
const visibleFooter = ref(false);
const switchFooter = () => {
  visibleFooter.value = !visibleFooter.value;
};

// 性别切换
const { role, changeRole } = roleHook();

// FB配置
const { fanSrc, appId } = fbHook();

try {
  point({
    eventName: 'view_page',
    value: 'PC首页',
    pageName: '',
    popupName: '',
    buttonName: 'PC首页',
    popupButtonName: '',
  });
} catch (e) {
  console.error(e);
}

// test
// showTipPopup(TipClassName.PhoneError);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            class: "sidebar-top-reserve",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showReservePopup) && _unref(showReservePopup)(...args)))
          }),
          _createElementVNode("a", {
            href: "//www.facebook.com/VintageShops.M/",
            class: "sidebar-top-fb",
            target: "_blank",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _unref(point)({
              eventName: 'click_button',
              value: 'FB',
              pageName: '',
              popupName: '',
              buttonName: 'FB',
              popupButtonName: '',
            })
          ))
          })
        ]),
        _createElementVNode("div", {
          class: "sidebar-center",
          onClick: changePage
        }, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            class: _normalizeClass(["sidebar-center-1", { active: pageState.activeIndex == 0 }]),
            "data-index": "0"
          }, null, 2),
          _createElementVNode("a", {
            href: "javascript:void(0);",
            class: _normalizeClass(["sidebar-center-2", { active: pageState.activeIndex == 1 }]),
            "data-index": "1"
          }, null, 2),
          _createElementVNode("a", {
            href: "javascript:void(0);",
            class: _normalizeClass(["sidebar-center-3", { active: pageState.activeIndex == 2 }]),
            "data-index": "2"
          }, null, 2),
          _createElementVNode("a", {
            href: "javascript:void(0);",
            class: _normalizeClass(["sidebar-center-4", { active: pageState.activeIndex == 3 }]),
            "data-index": "3"
          }, null, 2),
          _createElementVNode("a", {
            href: "javascript:void(0);",
            class: _normalizeClass(["sidebar-center-5", { active: pageState.activeIndex == 4 }]),
            "data-index": "4"
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(FbFans, {
            class: "fb-fans",
            fanSrc: _unref(fanSrc),
            appId: _unref(appId)
          }, null, 8, ["fanSrc", "appId"])
        ])
      ]),
      _createElementVNode("main", {
        class: "main swiper",
        ref_key: "pageSwiperEle",
        ref: pageSwiperEle
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Part1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(Part2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("section", _hoisted_13, [
              _createElementVNode("h2", {
                class: "part3-title",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(changeRole) && _unref(changeRole)(...args)))
              }, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: _normalizeClass(["part3-title-man", { active: _unref(role) == '1' }]),
                  "data-role": "1"
                }, null, 2),
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: _normalizeClass(["part3-title-woman", { active: _unref(role) == '0' }]),
                  "data-role": "0"
                }, null, 2)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_34, 512), [
                [_vShow, _unref(role) == '1']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_35, _hoisted_53, 512), [
                [_vShow, _unref(role) == '0']
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("section", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(CommonSwiper, {
                    swiperClassName: "swiper1",
                    autoPlay: worldSwiper1.autoPlay,
                    changeSwiperCallBack: worldSwiper1.changeSwiperCallBack,
                    imagesPathList: worldSwiper1.imagesPathList,
                    openLeftRightChangeBtn: worldSwiper1.openLeftRightChangeBtn,
                    openPaginationBtn: worldSwiper1.openPaginationBtn,
                    onGetSwiperInstance: worldSwiper1.getSwiperInstance
                  }, null, 8, ["autoPlay", "changeSwiperCallBack", "imagesPathList", "openLeftRightChangeBtn", "openPaginationBtn", "onGetSwiperInstance"])
                ]),
                _createElementVNode("div", {
                  class: "part4-left-bottom",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (worldSwiper1.changeSwiper1 && worldSwiper1.changeSwiper1(...args)))
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: _normalizeClass(["img2", { active: activeSwiper1Index.value == 0 }]),
                    "data-index": "0",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (
                    _unref(point)({
                      eventName: 'click_button',
                      value: '左图1',
                      pageName: '',
                      popupName: '',
                      buttonName: '左图1',
                      popupButtonName: '',
                    })
                  ))
                  }, null, 2),
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: _normalizeClass(["img3", { active: activeSwiper1Index.value == 1 }]),
                    "data-index": "1",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (
                    _unref(point)({
                      eventName: 'click_button',
                      value: '左图2',
                      pageName: '',
                      popupName: '',
                      buttonName: '左图2',
                      popupButtonName: '',
                    })
                  ))
                  }, null, 2),
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: _normalizeClass(["img4", { active: activeSwiper1Index.value == 2 }]),
                    "data-index": "2",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (
                    _unref(point)({
                      eventName: 'click_button',
                      value: '左图3',
                      pageName: '',
                      popupName: '',
                      buttonName: '左图3',
                      popupButtonName: '',
                    })
                  ))
                  }, null, 2)
                ]),
                _hoisted_58,
                _hoisted_59,
                _hoisted_60
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createVNode(CommonSwiper, {
                  swiperClassName: "swiper2",
                  imagesPathList: worldSwiper2.imagesPathList,
                  openLeftRightChangeBtn: worldSwiper2.openLeftRightChangeBtn,
                  onTouchStart: _cache[7] || (_cache[7] = ($event: any) => (
                  _unref(point)({
                    eventName: 'click_button',
                    value: '切换场景展示轮播图',
                    pageName: '',
                    popupName: '',
                    buttonName: '切换场景展示轮播图',
                    popupButtonName: '',
                  })
                ))
                }, null, 8, ["imagesPathList", "openLeftRightChangeBtn"])
              ]),
              _hoisted_63
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createVNode(Part5, { imagesPathList: swiper3ImagesPathList })
          ])
        ]),
        _createElementVNode("footer", {
          class: _normalizeClass(["footer", { active: visibleFooter.value }])
        }, [
          _createElementVNode("div", {
            class: "footer-copyright",
            onClick: switchFooter
          }, _hoisted_67),
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "footer-close",
            onClick: switchFooter
          }),
          _hoisted_68
        ], 2)
      ], 512)
    ]),
    _createVNode(ReservePopup, {
      visible: _unref(visibleReservePopup),
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_isRef(visibleReservePopup) ? (visibleReservePopup).value = $event : null))
    }, null, 8, ["visible"]),
    _createVNode(TipPopup, {
      visible: _unref(visibleTipPopup),
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(visibleTipPopup) ? (visibleTipPopup).value = $event : null)),
      tipClass: _unref(tipClass),
      tipMsg: _unref(tipMsg)
    }, null, 8, ["visible", "tipClass", "tipMsg"])
  ], 64))
}
}

})